//#region src/lib/classify.ts
var e = [
	"background",
	"fill",
	"line",
	"circle"
], t = ["line-gradient", "line-pattern"], n = ["line-blur", "circle-blur"], r = ["fill-pattern", "background-pattern"], i = (e) => e != null;
function a(a, o) {
	let s = "layout" in a ? a.layout : void 0, c = ("paint" in a ? a.paint : void 0) ?? {};
	if (s?.visibility === "none" || a.minzoom !== void 0 && o.zoom < a.minzoom || a.maxzoom !== void 0 && o.zoom >= a.maxzoom) return "skip";
	if (a.type === "symbol") {
		if (o.labels !== "vector") return "symbol";
		if (!i(s?.["icon-image"])) return "vector";
		let e = s?.["symbol-placement"];
		return !o.hasImages || i(e) && e !== "point" ? "symbol" : "vector";
	}
	return !e.includes(a.type) || a.type === "circle" && o.pitch > 0 && (c["circle-pitch-scale"] !== "viewport" || c["circle-pitch-alignment"] === "map") || a.type === "background" && Object.values(c).some((e) => Array.isArray(e)) || t.some((e) => i(c[e])) || n.some((e) => i(c[e]) && c[e] !== 0) || !o.hasImages && r.some((e) => i(c[e])) ? "raster" : "vector";
}
function o(e, t) {
	let n = [], r = [];
	for (let i of e) {
		let e = a(i, t);
		if (e === "skip") continue;
		if (e === "symbol") {
			r.push(i.id);
			continue;
		}
		let o = n[n.length - 1];
		e === "vector" ? o?.kind === "vector" ? o.layers.push(i) : n.push({
			kind: "vector",
			layers: [i]
		}) : o?.kind === "raster" ? o.layerIds.push(i.id) : n.push({
			kind: "raster",
			layerIds: [i.id]
		});
	}
	return r.length > 0 && n.push({
		kind: "raster",
		layerIds: r
	}), n;
}
//#endregion
//#region src/lib/color.ts
var s = (e) => Math.max(0, Math.min(255, Math.round(e))).toString(16).padStart(2, "0"), c = (e, t, n) => `#${s(e)}${s(t)}${s(n)}`;
function l(e) {
	let t = e.trim(), n = /^#([0-9a-f]{3,8})$/i.exec(t)?.[1];
	if (n && (n.length === 4 || n.length === 8)) {
		let e = n.length === 4 ? [...n].map((e) => e + e).join("") : n;
		return {
			color: `#${e.slice(0, 6)}`,
			opacity: parseInt(e.slice(6), 16) / 255
		};
	}
	let r = /^rgba?\(([^)]+)\)$/i.exec(t);
	if (r) {
		let e = r[1].split(/[\s,/]+/).filter(Boolean), t = (e) => e.endsWith("%") ? parseFloat(e) * 255 / 100 : parseFloat(e), n = e[3];
		return {
			color: c(t(e[0]), t(e[1]), t(e[2])),
			opacity: n === void 0 ? 1 : n.endsWith("%") ? parseFloat(n) / 100 : parseFloat(n)
		};
	}
	return {
		color: t,
		opacity: t === "transparent" ? 0 : 1
	};
}
function u(e, t = "#000000") {
	if (typeof e == "string") return l(e);
	if (e && typeof e == "object" && "r" in e && "g" in e && "b" in e) {
		let { r: t, g: n, b: r, a: i = 1 } = e;
		return i <= 0 ? {
			color: "#000000",
			opacity: 0
		} : {
			color: c(t / i * 255, n / i * 255, r / i * 255),
			opacity: i
		};
	}
	return l(t);
}
//#endregion
//#region src/lib/svg.ts
var d = "http://www.w3.org/2000/svg", f = "http://www.w3.org/1999/xlink";
function p(e) {
	let t = Math.round(e * 100) / 100;
	return Object.is(t, -0) ? "0" : String(t);
}
function m(e, t) {
	for (let [n, r] of Object.entries(t)) {
		if (r === void 0) continue;
		let t = typeof r == "number" ? p(r) : r;
		n === "href" && e.setAttributeNS(f, "xlink:href", t), e.setAttribute(n, t);
	}
}
function h(e, t, n = {}, r = []) {
	let i = e.createElementNS(d, t);
	m(i, n);
	for (let e of r) i.appendChild(e);
	return i;
}
function g(e) {
	let t = e.replace(/[^A-Za-z0-9_.-]/g, "_");
	return /^[A-Za-z_]/.test(t) ? t : `_${t}`;
}
function _() {
	let e = /* @__PURE__ */ new Set();
	return (t) => {
		let n = g(t), r = n;
		for (let t = 2; e.has(r); t++) r = `${n}-${t}`;
		return e.add(r), r;
	};
}
function v(e, t, n = []) {
	if (t.length < 2) return;
	let [r, ...i] = t;
	for (let [a, o] of Object.entries(r)) if (!(o === void 0 || n.includes(a)) && i.every((e) => e[a] === o)) {
		m(e, { [a]: o });
		for (let e of t) delete e[a];
	}
}
function y(e) {
	return `<?xml version="1.0" encoding="UTF-8"?>\n${new XMLSerializer().serializeToString(e)}`;
}
//#endregion
//#region src/lib/pattern.ts
var b = (e, t, n) => {
	let r = document.createElement("canvas");
	r.width = t, r.height = n;
	let i = r.getContext("2d");
	if (!i) throw Error("Failed to get 2D context to encode an image");
	let a = i.createImageData(t, n);
	return a.data.set(e), i.putImageData(a, 0, 0), r.toDataURL("image/png");
}, x = .75, S = .06;
function ee(e, t) {
	let n = new Uint8ClampedArray(e.length);
	for (let r = 0; r < e.length; r += 4) {
		let i = (e[r + 3] / 255 - x) / S + .5;
		n[r] = t[0], n[r + 1] = t[1], n[r + 2] = t[2], n[r + 3] = Math.max(0, Math.min(1, i)) * 255;
	}
	return n;
}
function C(e) {
	if (typeof e == "string") return e || void 0;
	if (!e || typeof e != "object") return;
	let t = e;
	return typeof t.name == "string" ? t.name || void 0 : C(t.from) ?? C(t.to);
}
var te = class {
	doc;
	defs;
	getImage;
	id;
	encode;
	images = /* @__PURE__ */ new Map();
	patterns = /* @__PURE__ */ new Map();
	constructor(e, t, n, r, i = b) {
		this.doc = e, this.defs = t, this.getImage = n, this.id = r, this.encode = i;
	}
	get available() {
		return this.getImage !== void 0;
	}
	image(e, t = "#000000") {
		let n = this.read(e), r = n?.sdf ? `${e}\u0000${t}` : e;
		if (this.images.has(r)) return this.images.get(r);
		let i;
		if (n) {
			let { width: r, height: a, data: o } = n.data, s = n.pixelRatio || 1, c = n.sdf ? ee(o, [
				parseInt(t.slice(1, 3), 16) || 0,
				parseInt(t.slice(3, 5), 16) || 0,
				parseInt(t.slice(5, 7), 16) || 0
			]) : new Uint8ClampedArray(o.buffer, o.byteOffset, o.byteLength);
			i = {
				id: this.id(`image-${this.images.size}-${e}`),
				width: r / s,
				height: a / s
			}, this.defs.appendChild(h(this.doc, "image", {
				id: i.id,
				width: i.width,
				height: i.height,
				href: this.encode(c, r, a)
			}));
		}
		return this.images.set(r, i), i;
	}
	pattern(e) {
		if (this.patterns.has(e)) return this.patterns.get(e);
		let t = this.image(e), n;
		return t && (n = this.id(`pattern-${this.patterns.size}-${e}`), this.defs.appendChild(h(this.doc, "pattern", {
			id: n,
			width: t.width,
			height: t.height,
			patternUnits: "userSpaceOnUse"
		}, [h(this.doc, "use", { href: `#${t.id}` })]))), this.patterns.set(e, n), n;
	}
	read(e) {
		try {
			let t = this.getImage?.(e);
			return t?.data?.data ? t : void 0;
		} catch {
			return;
		}
	}
}, w = (e, t, n) => e?.[t] ?? n;
function T(e) {
	let t = e?.paint, n = e?.layout;
	return {
		paint: (e, n) => w(t, e, n),
		layout: (e, t) => w(n, e, t)
	};
}
//#endregion
//#region src/lib/tile-clip.ts
var E = (e) => e ? `${e.z}/${e.x}/${e.y}` : "", D = (e, t) => e / 2 ** t * 360 - 180, O = (e, t) => Math.atan(Math.sinh(Math.PI * (1 - 2 * e / 2 ** t))) * 180 / Math.PI;
function k({ z: e, x: t, y: n }) {
	let r = D(t, e), i = D(t + 1, e), a = O(n, e), o = O(n + 1, e);
	return [
		[r, a],
		[i, a],
		[i, o],
		[r, o]
	];
}
function ne(e, t, n = 0) {
	let r = k(e).map(t);
	if (n === 0) return r;
	let i = r.reduce((e, t) => e + t.x, 0) / r.length, a = r.reduce((e, t) => e + t.y, 0) / r.length;
	return r.map((e) => {
		let t = e.x - i, r = e.y - a, o = Math.hypot(t, r) || 1;
		return {
			x: e.x + t / o * n,
			y: e.y + r / o * n
		};
	});
}
function A([e, t], { z: n, x: r, y: i }) {
	let a = 2 ** n, o = (e + 180) / 360 * a, s = Math.sin(t * Math.PI / 180), c = (.5 - Math.log((1 + s) / (1 - s)) / (4 * Math.PI)) * a;
	return o >= r && o < r + 1 && c >= i && c < i + 1;
}
//#endregion
//#region src/lib/layers/common.ts
var re = .5;
function j(e, t) {
	return h(e.doc, "g", {
		id: e.id(t.id),
		"data-layer": t.id,
		"data-type": t.type
	});
}
function M(e) {
	let t = /* @__PURE__ */ new Map();
	for (let n of e) {
		let { tile: e } = n, r = E(e), i = t.get(r);
		i || (i = {
			tile: e,
			features: []
		}, t.set(r, i)), i.features.push(n);
	}
	return [...t.values()];
}
function N(e, t) {
	if (!t) return h(e.doc, "g");
	let n = E(t), r = e.clipIds.get(n);
	if (!r) {
		r = e.id(`tile-${t.z}-${t.x}-${t.y}`);
		let i = ne(t, e.project, re).map((e) => `${p(e.x)},${p(e.y)}`).join(" ");
		e.defs.appendChild(h(e.doc, "clipPath", { id: r }, [h(e.doc, "polygon", { points: i })])), e.clipIds.set(n, r);
	}
	return h(e.doc, "g", { "clip-path": `url(#${r})` });
}
function P(e, t, n) {
	let [r, i] = t;
	if (r === 0 && i === 0) return e.project;
	if (n !== "viewport") {
		let t = -e.bearing * Math.PI / 180;
		[r, i] = [r * Math.cos(t) - i * Math.sin(t), r * Math.sin(t) + i * Math.cos(t)];
	}
	return (t) => {
		let n = e.project(t);
		return {
			x: n.x + r,
			y: n.y + i
		};
	};
}
function F(e, t, n, r) {
	let i = j(n, e), a = [];
	for (let { tile: e, features: o } of M(t)) {
		let t = o.map((e) => r(e, n)).filter((e) => e !== void 0);
		if (t.length === 0) continue;
		let s = N(n, e);
		i.appendChild(s);
		for (let e of t) a.push({
			parent: s,
			attrs: e
		});
	}
	if (a.length !== 0) {
		v(i, a.map(({ attrs: e }) => e), ["d"]);
		for (let { parent: e, attrs: t } of a) e.appendChild(h(n.doc, "path", t));
		return i;
	}
}
//#endregion
//#region src/lib/layers/background.ts
function ie(e, t) {
	let n = T(e), r = n.paint("background-opacity", 1), i = C(n.paint("background-pattern")), a = i ? t.images.pattern(i) : void 0, { color: o, opacity: s } = u(n.paint("background-color")), c = (typeof r == "number" ? r : 1) * (a ? 1 : s);
	if (c <= 0) return;
	let l = j(t, e);
	return l.appendChild(h(t.doc, "rect", {
		width: t.width,
		height: t.height,
		fill: a ? `url(#${a})` : o,
		"fill-opacity": c === 1 ? void 0 : c
	})), l;
}
//#endregion
//#region src/lib/layers/circle.ts
function I(e) {
	switch (e.type) {
		case "Point": return [e.coordinates];
		case "MultiPoint":
		case "LineString": return e.coordinates;
		case "MultiLineString":
		case "Polygon": return e.coordinates.flat();
		case "MultiPolygon": return e.coordinates.flat(2);
		case "GeometryCollection": return e.geometries.flatMap(I);
		default: return [];
	}
}
function ae(e, t) {
	let n = T(e.layer), r = n.paint("circle-radius", 5), i = u(n.paint("circle-color")), a = n.paint("circle-opacity", 1) * i.opacity, o = n.paint("circle-stroke-width", 0), s = u(n.paint("circle-stroke-color")), c = o > 0 ? n.paint("circle-stroke-opacity", 1) * s.opacity : 0;
	if (r + o <= 0 || a <= 0 && c <= 0) return [];
	let l = P(t, n.paint("circle-translate", [0, 0]), n.paint("circle-translate-anchor", "map")), { tile: d } = e;
	return I(e.geometry).filter((e) => !d || A(e, d)).map((e) => {
		let t = l([e[0], e[1]]);
		return {
			cx: t.x,
			cy: t.y,
			r: r + o / 2,
			fill: a > 0 ? i.color : "none",
			"fill-opacity": a > 0 && a < 1 ? a : void 0,
			stroke: c > 0 ? s.color : void 0,
			"stroke-width": c > 0 ? o : void 0,
			"stroke-opacity": c > 0 && c < 1 ? c : void 0
		};
	});
}
function oe(e, t, n) {
	let r = /* @__PURE__ */ new Set(), i = t.flatMap((e) => ae(e, n).map((t) => ({
		attrs: t,
		key: `${e.id ?? JSON.stringify(e.properties)}@${p(t.cx)},${p(t.cy)}`
	}))).filter(({ key: e }) => !r.has(e) && r.add(e)).map(({ attrs: e }) => e);
	if (i.length === 0) return;
	let a = j(n, e);
	v(a, i, [
		"cx",
		"cy",
		"r"
	]);
	for (let e of i) a.appendChild(h(n.doc, "circle", e));
	return a;
}
//#endregion
//#region src/lib/geometry.ts
var L = (e, t) => e.map((e) => t([e[0], e[1]]));
function R(e, t) {
	switch (e.type) {
		case "LineString": return [{
			points: L(e.coordinates, t),
			closed: !1
		}];
		case "MultiLineString": return e.coordinates.map((e) => ({
			points: L(e, t),
			closed: !1
		}));
		case "Polygon": return e.coordinates.map((e) => ({
			points: L(e, t),
			closed: !0
		}));
		case "MultiPolygon": return e.coordinates.flatMap((e) => e.map((e) => ({
			points: L(e, t),
			closed: !0
		})));
		case "GeometryCollection": return e.geometries.flatMap((e) => R(e, t));
		default: return [];
	}
}
function z(e, t) {
	switch (e.type) {
		case "Point": return L([e.coordinates], t);
		case "MultiPoint": return L(e.coordinates, t);
		case "GeometryCollection": return e.geometries.flatMap((e) => z(e, t));
		default: return R(e, t).flatMap((e) => e.points);
	}
}
function B(e) {
	let t = [];
	for (let { points: n, closed: r } of e) {
		if (n.length < 2) continue;
		let e = "";
		n.forEach((n, r) => {
			let i = `${p(n.x)} ${p(n.y)}`;
			i !== e && (e = i, t.push(`${r === 0 ? "M" : "L"}${i}`));
		}), r && t.push("Z");
	}
	return t.join("");
}
function V(e) {
	let t = 0;
	for (let n = 1; n < e.length; n++) t += Math.hypot(e[n].x - e[n - 1].x, e[n].y - e[n - 1].y);
	return t;
}
var H = 4;
function U(e, t) {
	let { closed: n } = e, r = n && e.points.length > 1 && e.points[0].x === e.points[e.points.length - 1].x && e.points[0].y === e.points[e.points.length - 1].y ? e.points.slice(0, -1) : e.points, i = r.length;
	if (t === 0 || i < 2) return e;
	let a = (e, t) => {
		let n = t.x - e.x, r = t.y - e.y, i = Math.hypot(n, r);
		return i === 0 ? void 0 : {
			x: -r / i,
			y: n / i
		};
	}, o = r.map((e, o) => {
		let s = n || o > 0, c = n || o < i - 1, l = s ? a(r[(o - 1 + i) % i], e) : void 0, u = c ? a(e, r[(o + 1) % i]) : void 0, d = l ?? u, f = u ?? l;
		if (!d || !f) return e;
		let p = d.x + f.x, m = d.y + f.y, h = Math.hypot(p, m);
		if (h < 1e-6) return {
			x: e.x + d.x * t,
			y: e.y + d.y * t
		};
		let g = p / h * d.x + m / h * d.y, _ = Math.min(1 / Math.max(g, 1e-6), H) * t;
		return {
			x: e.x + p / h * _,
			y: e.y + m / h * _
		};
	});
	return n && o.push(o[0]), {
		points: o,
		closed: n
	};
}
//#endregion
//#region src/lib/layers/fill.ts
function W(e, t) {
	let n = T(e.layer), r = n.paint("fill-opacity", 1);
	if (r <= 0) return;
	let i = P(t, n.paint("fill-translate", [0, 0]), n.paint("fill-translate-anchor", "map")), a = B(R(e.geometry, i));
	if (!a) return;
	let o = C(n.paint("fill-pattern")), s = o ? t.images.pattern(o) : void 0, c = u(n.paint("fill-color")), l = r * (s ? 1 : c.opacity), d = {
		d: a,
		fill: s ? `url(#${s})` : c.color,
		"fill-opacity": l === 1 ? void 0 : l,
		"fill-rule": "evenodd"
	}, f = n.paint("fill-outline-color");
	if (f != null && n.paint("fill-antialias", !0)) {
		let e = u(f), t = r * e.opacity;
		t > 0 && (d.stroke = e.color, d["stroke-width"] = 1, d["stroke-opacity"] = t === 1 ? void 0 : t);
	}
	return d;
}
function G(e, t, n) {
	return F(e, t, n, W);
}
//#endregion
//#region src/lib/layers/line.ts
function K(e, t) {
	let n = Array.isArray(e) ? e : e?.from ?? e?.to;
	if (!(!Array.isArray(n) || n.length < 2) && n.every((e) => typeof e == "number")) return n.map((e) => p(Math.max(0, e * t))).join(" ");
}
function se(e, t) {
	let n = T(e.layer), r = n.paint("line-width", 1), i = u(n.paint("line-color")), a = n.paint("line-opacity", 1) * i.opacity;
	if (r <= 0 || a <= 0) return;
	let o = P(t, n.paint("line-translate", [0, 0]), n.paint("line-translate-anchor", "map")), s = n.paint("line-offset", 0), c = n.paint("line-gap-width", 0), l = c > 0 ? [s - (c + r) / 2, s + (c + r) / 2] : [s], d = R(e.geometry, o), f = B(l.flatMap((e) => d.map((t) => U(t, e))));
	if (!f) return;
	let p = n.layout("line-join", "miter");
	return {
		d: f,
		fill: "none",
		stroke: i.color,
		"stroke-width": r,
		"stroke-opacity": a === 1 ? void 0 : a,
		"stroke-linecap": n.layout("line-cap", "butt"),
		"stroke-linejoin": p,
		"stroke-miterlimit": p === "miter" ? n.layout("line-miter-limit", 2) : void 0,
		"stroke-dasharray": K(n.paint("line-dasharray"), r)
	};
}
function ce(e, t, n) {
	return F(e, t, n, se);
}
//#endregion
//#region src/lib/layers/symbol.ts
var q = .35;
function J(e) {
	if (typeof e == "string") return e;
	if (typeof e == "number") return String(e);
	let t = e?.sections;
	return Array.isArray(t) ? t.map((e) => typeof e.text == "string" ? e.text : "").join("") : "";
}
function Y(e) {
	let t = 0;
	for (let n of e) t += n.charCodeAt(0) > 11903 ? 1 : .55;
	return t;
}
function le(e, t) {
	let n = [];
	for (let r of e.split("\n")) {
		let e = "";
		for (let i of r.split(" ")) {
			let r = e ? `${e} ${i}` : i;
			e && t > 0 && Y(r) > t ? (n.push(e), e = i) : e = r;
		}
		n.push(e);
	}
	return n.filter((e) => e.length > 0);
}
function ue(e) {
	let t = Array.isArray(e) && typeof e[0] == "string" ? e[0] : "", n = /\b(bold|black|heavy)\b/i.test(t), r = /\b(italic|oblique)\b/i.test(t), i = t.replace(/\b(regular|bold|black|heavy|medium|light|italic|oblique|semibold|book)\b/gi, "").replace(/\s+/g, " ").trim();
	return {
		"font-family": i ? `'${i}', sans-serif` : "sans-serif",
		"font-weight": n ? "bold" : void 0,
		"font-style": r ? "italic" : void 0
	};
}
function X(e, t) {
	return t === "uppercase" ? e.toUpperCase() : t === "lowercase" ? e.toLowerCase() : e;
}
function de(e) {
	let t = e.map((e) => e.x), n = e.map((e) => e.y);
	return {
		x: (Math.min(...t) + Math.max(...t)) / 2,
		y: (Math.min(...n) + Math.max(...n)) / 2
	};
}
function fe(e, t) {
	let { geometry: n, tile: r } = e;
	if (n.type === "Point" || n.type === "MultiPoint") return (n.type === "Point" ? [n.coordinates] : n.coordinates).filter((e) => !r || A(e, r)).map((e) => t.project([e[0], e[1]]));
	let i = z(n, t.project);
	return i.length > 0 ? [de(i)] : [];
}
function pe(e, t, n) {
	let r = T(e.layer), i = C(r.layout("icon-image"));
	if (!i) return;
	let a = u(r.paint("icon-color")), o = r.paint("icon-opacity", 1), s = n.images.image(i, a.color);
	if (!s || o <= 0) return;
	let c = r.layout("icon-size", 1), [l, d] = r.layout("icon-offset", [0, 0]), f = r.layout("icon-anchor", "center"), m = f.includes("left") ? 0 : f.includes("right") ? 1 : .5, g = f.includes("top") ? 0 : f.includes("bottom") ? 1 : .5, _ = r.layout("icon-rotate", 0), v = [
		`translate(${p(t.x)} ${p(t.y)})`,
		_ ? `rotate(${p(_)})` : "",
		c === 1 ? "" : `scale(${p(c)})`,
		`translate(${p(l - s.width * m)} ${p(d - s.height * g)})`
	].filter(Boolean).join(" ");
	return h(n.doc, "use", {
		href: `#${s.id}`,
		transform: v,
		opacity: o === 1 ? void 0 : o
	});
}
function Z(e) {
	let t = T(e.layer), n = t.layout("text-size", 16), r = u(t.paint("text-color")), i = t.paint("text-opacity", 1), a = u(t.paint("text-halo-color"), "rgba(0,0,0,0)"), o = t.paint("text-halo-width", 0), s = t.layout("text-letter-spacing", 0) * n;
	return {
		size: n,
		base: {
			...ue(t.layout("text-font")),
			"font-size": n,
			"letter-spacing": s || void 0
		},
		text: {
			fill: r.color,
			"fill-opacity": i * r.opacity === 1 ? void 0 : i * r.opacity
		},
		halo: o > 0 && a.opacity > 0 ? {
			fill: "none",
			stroke: a.color,
			"stroke-width": o * 2,
			"stroke-linejoin": "round",
			"stroke-opacity": i * a.opacity === 1 ? void 0 : i * a.opacity
		} : void 0,
		visible: i > 0 && n > 0
	};
}
function me(e, t, n) {
	let r = T(e.layer), i = Z(e), a = le(X(J(r.layout("text-field")), r.layout("text-transform", "none")), r.layout("text-max-width", 10));
	if (!i.visible || a.length === 0) return;
	let { size: o } = i, s = r.layout("text-variable-anchor"), c = Array.isArray(s) && typeof s[0] == "string" ? s[0] : r.layout("text-anchor", "center"), [l, u] = r.layout("text-offset", [0, 0]), d = r.layout("text-line-height", 1.2) * o, f = d * a.length, m = t.x + l * o, g = t.y + u * o - (c.includes("top") ? 0 : c.includes("bottom") ? f : f / 2) + d / 2 + o * q, _ = r.layout("text-rotate", 0), v = {
		...i.base,
		"text-anchor": c.includes("left") ? "start" : c.includes("right") ? "end" : "middle",
		transform: _ ? `rotate(${p(_)} ${p(t.x)} ${p(t.y)})` : void 0
	}, y = (e) => h(n.doc, "text", {
		...v,
		...e
	}, a.map((e, t) => {
		let r = h(n.doc, "tspan", {
			x: m,
			y: g + t * d
		});
		return r.textContent = e, r;
	}));
	return i.halo ? [y(i.halo), y(i.text)] : [y(i.text)];
}
function Q(e, t, n, r) {
	let i = T(e.layer), a = Z(e), o = X(J(i.layout("text-field")), i.layout("text-transform", "none")).replace(/\n/g, " ");
	if (!a.visible || !o || V(t.points) < Y(o) * a.size) return;
	let s = t.points[0], c = t.points[t.points.length - 1], l = s.x <= c.x ? t.points : [...t.points].reverse();
	n.defs.appendChild(h(n.doc, "path", {
		id: r,
		d: B([{
			points: l,
			closed: !1
		}]),
		fill: "none"
	}));
	let u = (e) => {
		let t = h(n.doc, "textPath", {
			href: `#${r}`,
			startOffset: "50%"
		});
		return t.textContent = o, h(n.doc, "text", {
			...a.base,
			"text-anchor": "middle",
			dy: a.size * q,
			...e
		}, [t]);
	};
	return a.halo ? [u(a.halo), u(a.text)] : [u(a.text)];
}
function he(e, t, n) {
	let r = j(n, e), i = /* @__PURE__ */ new Set(), a = 0;
	for (let o of t) {
		let t = T(o.layer), s = `${o.id ?? ""}|${JSON.stringify(o.properties)}`, c = [];
		if (t.layout("symbol-placement", "point") === "point") for (let e of fe(o, n)) {
			let t = `${s}@${p(e.x)},${p(e.y)}`;
			if (i.has(t)) continue;
			i.add(t);
			let r = pe(o, e, n);
			r && c.push(r), c.push(...me(o, e, n) ?? []);
		}
		else {
			let t = R(o.geometry, n.project).filter((e) => e.points.length > 1).sort((e, t) => V(t.points) - V(e.points))[0];
			if (t) {
				let r = n.id(`${e.id}-path-${a++}`);
				c.push(...Q(o, t, n, r) ?? []);
			}
		}
		c.length === 1 ? r.appendChild(c[0]) : c.length > 1 && r.appendChild(h(n.doc, "g", {}, c));
	}
	return r.childNodes.length > 0 ? r : void 0;
}
//#endregion
//#region src/lib/types.ts
var $ = class extends Error {
	constructor(e) {
		super(e), this.name = "UnsupportedMapError";
	}
};
//#endregion
//#region src/lib/map.ts
function ge(e) {
	if (e.getTerrain?.()) throw new $("A map with terrain cannot be converted to vectors");
	let t = e.getProjection?.()?.type;
	if (t != null && t !== "mercator") throw new $("Only a map in the mercator projection can be converted to vectors");
}
function _e(e) {
	let t = e.getCanvas();
	return {
		width: parseFloat(t.style.width) || t.clientWidth || t.width,
		height: parseFloat(t.style.height) || t.clientHeight || t.height
	};
}
function ve(e) {
	let { _z: t, _x: n, _y: r } = e;
	if (typeof t == "number" && typeof n == "number" && typeof r == "number") return {
		z: t,
		x: n,
		y: r
	};
}
function ye(e, t) {
	return e.queryRenderedFeatures({ layers: [t] }).reverse().map((e) => ({
		id: e.id,
		geometry: e.geometry,
		properties: e.properties,
		layer: e.layer,
		tile: ve(e)
	}));
}
function be(e, t) {
	return new Promise((n) => {
		let r = setTimeout(n, t);
		e.once("idle", () => {
			clearTimeout(r), n();
		});
	});
}
//#endregion
//#region src/lib/raster-pass.ts
async function xe(e, t, n, r) {
	if (t.length === 0) return [];
	let i = (t, n) => e.setLayoutProperty(t, "visibility", n ? "visible" : "none"), a = [], o = new Set(n);
	try {
		for (let s of t) {
			let t = new Set(s), c = !1;
			for (let e of n) o.has(e) !== t.has(e) && (i(e, t.has(e)), t.has(e) ? o.add(e) : o.delete(e), c = !0);
			c && await be(e, r), a.push(e.getCanvas().toDataURL("image/png"));
		}
	} finally {
		for (let e of n) o.has(e) || i(e, !0);
	}
	return a;
}
//#endregion
//#region src/lib/index.ts
function Se(e, t, n) {
	if (e.type === "background") return ie(e, n);
	let r = ye(t, e.id);
	if (r.length !== 0) switch (e.type) {
		case "fill": return G(e, r, n);
		case "line": return ce(e, r, n);
		case "circle": return oe(e, r, n);
		case "symbol": return he(e, r, n);
		default: return;
	}
}
async function Ce(e, t = {}) {
	ge(e);
	let n = document, { width: r, height: i } = _e(e), s = t.unit ?? "mm", c = s === "px" ? "" : s, l = n.createElementNS(d, "svg");
	l.setAttribute("xmlns", d), l.setAttribute("xmlns:xlink", f), l.setAttribute("version", "1.1"), l.setAttribute("width", `${t.width ?? r}${t.width ? c : ""}`), l.setAttribute("height", `${t.height ?? i}${t.height ? c : ""}`), l.setAttribute("viewBox", `0 0 ${r} ${i}`);
	let u = h(n, "defs");
	l.appendChild(u);
	let p = typeof e.getImage == "function" ? (t) => e.getImage(t) : void 0, m = _(), g = {
		doc: n,
		defs: u,
		project: (t) => {
			let { x: n, y: r } = e.project(t);
			return {
				x: n,
				y: r
			};
		},
		bearing: e.getBearing(),
		width: r,
		height: i,
		images: new te(n, u, p, m, t.encodeImage),
		id: m,
		clipIds: /* @__PURE__ */ new Map()
	}, v = e.getStyle()?.layers ?? [], y = {
		zoom: e.getZoom(),
		pitch: e.getPitch(),
		labels: t.labels ?? "raster",
		hasImages: p !== void 0
	}, b = o(v, y), x = [];
	for (let t of b) if (t.kind === "raster") {
		let e = h(n, "image", {
			width: r,
			height: i,
			"data-layers": t.layerIds.join(" ")
		});
		x.push(e), l.appendChild(e);
	} else for (let n of t.layers) {
		let t = Se(n, e, g);
		t && l.appendChild(t);
	}
	let S = await xe(e, b.flatMap((e) => e.kind === "raster" ? [e.layerIds] : []), v.filter((e) => a(e, y) !== "skip").map((e) => e.id), t.idleTimeout ?? 5e3);
	return x.forEach((e, t) => {
		e.setAttributeNS(f, "xlink:href", S[t]), e.setAttribute("href", S[t]);
	}), l;
}
//#endregion
export { $ as UnsupportedMapError, o as buildSegments, a as classifyLayer, Ce as maplibre2svg, T as properties, y as svgToString };

//# sourceMappingURL=maplibre2svg.es.js.map